import { Button, ConsoleDialog, TextField } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

import type { useDuplicateCustomPriceList } from './hooks/useDuplicateCustomPriceList';

interface DuplicateCustomPriceListDialogProps {
  duplicate: ReturnType<typeof useDuplicateCustomPriceList>;
}

//
// ⚛️ ⚛️ ⚛️ DUPLICATE CUSTOM PRICE LIST DIALOG ⚛️ ⚛️ ⚛️
//
export const DuplicateCustomPriceListDialog = ({
  duplicate,
}: DuplicateCustomPriceListDialogProps) => {
  const t = useTranslations();

  return (
    <ConsoleDialog
      className="@DuplicateCustomPriceListDialog"
      isOpen={duplicate.dialogProps.isOpen}
      onOpenChange={(open) => {
        if (!open) duplicate.dialogProps.close();
      }}
      title={t.pricing.customPriceLists.detail.actions.duplicate}
      content={
        <TextField
          label={t.pricing.customPriceLists.create.fields.name}
          value={duplicate.duplicateName}
          onChange={duplicate.setDuplicateName}
          isRequired
        />
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button
            variant="outline"
            color="neutral"
            onPress={duplicate.dialogProps.close}
            isDisabled={duplicate.isDuplicating}
          >
            {t.common.actions.cancel}
          </Button>
          <Button
            variant="solid"
            color="primary"
            onPress={duplicate.handleSubmitDuplicate}
            isDisabled={
              !duplicate.duplicateName.trim() || duplicate.isDuplicating
            }
          >
            {duplicate.isDuplicating
              ? t.common.loading.creating
              : t.pricing.customPriceLists.detail.actions.duplicate}
          </Button>
        </div>
      }
    />
  );
};
